/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import * as _ from 'lodash';

import template from './campaign-analysis-page.component.html';
import {campaignCommons} from './campaign-commons';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-campaign-analysis-page',
  template
})
export class CampaignAnalysisPageComponent implements OnChanges {
  @Input() model: any;
  @Input() unrejectError = false;

  private _lir: any;
  private _isNewDirect: boolean | undefined;

  @Input()
  set lir(value: any) {
    this._lir = value;
    this.syncCreatives();
  }

  get lir(): any {
    return this._lir;
  }

  @Input()
  set isNew(value: boolean) {
    this._isNewDirect = value;
  }

  get isNew(): boolean {
    return this._isNewDirect;
  }

  @Output() unrejectCreative = new EventEmitter<any>();
  @Output() editCreativeTarget = new EventEmitter<{targeting: any; creative: any}>();

  effectiveIsNew = false;
  activeTab: 'creative' | 'statistics' = 'creative';
  activeCreativeIndex = 0;
  showingChart: string | null = null;
  creatives: any[] = [];
  maxWidth = 100;
  maxHeight = 100;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if (changes.lir) {
      this.syncCreatives();
    }
  }

  selectCreativeTab(index: number): void {
    this.activeTab = 'creative';
    this.activeCreativeIndex = index;
    this.showingChart = null;
  }

  selectStatistics(): void {
    this.activeTab = 'statistics';
    this.showingChart = 'LINE_ITEM';
  }

  onUnreject(creative: any): void {
    this.unrejectCreative.emit(creative);
  }

  onEditCreativeTarget(targeting: any, creative: any): void {
    this.editCreativeTarget.emit({targeting, creative});
  }

  trackCreative(index: number, creative: any): any {
    return creative?.creative?.id || creative?.id || index;
  }

  private syncCreatives(): void {
    const next = _.get(this._lir, 'creatives');
    this.creatives = Array.isArray(next) ? next : [];
    if (this._lir) {
      campaignCommons(this).setUpComponents(['lir']);
    }
  }

}
